<template>
  <div class="ao__media">
    <DefaultArticlesArtObjectsGallery v-if="assetIds.length > 1" :images="assetsStore.getAssets(assetIds)" />
    <DefaultArticlesArtObjectsImage
      v-else-if="payload?.attributes?.src && isImage(createAsset(payload?.attributes))"
      :image="createAsset(payload?.attributes)"
      :width="Number(payload?.attributes?.width)"
      :height="Number(payload?.attributes?.height)"
    />
    <DefaultArticlesArtObjectsImage
      v-else-if="asset && isImage(asset)"
      :image="asset"
      :width="Number(payload?.attributes?.width)"
      :height="Number(payload?.attributes?.height)"
    />
    <DefaultArticlesArtObjectsVideo
      v-else-if="asset && isVideo(asset)"
      :asset="asset"
    />
  </div>
</template>

<script setup lang="ts">
import type AssetLocal from "~/libs/interfaces/AssetLocal";

const {payload} = defineProps<{
  payload?: any
}>()

const imageContentTypes = ['image/png', 'image/jpeg', 'image/webp']
const imageSuffixes = ['png', 'jpg', 'jpeg', 'webp']
const videoContentTypes = ['video/vp']

const createAsset = (attributes: any):AssetLocal => {
  return {
    urlWithProtocol: attributes.src,
    srcset: attributes.srcset,
    alt: attributes.alt,
  } as AssetLocal
}

const isImage = (asset?:AssetLocal) => {
  if (!asset?.contentType) {
    if (asset?.urlWithProtocol) {
      const suffix = asset?.urlWithProtocol.split('.').pop()
      return suffix && imageSuffixes.includes(suffix.toLowerCase())
    }
    return false
  }
  return imageContentTypes.includes(asset.contentType)
}

const isVideo = (asset?: AssetLocal) => {
  if (!asset?.contentType) {
    return false
  }
  return videoContentTypes.includes(asset.contentType)
}

const assetsStore = useAssetsStore()

const assetIds = computed(() => {
  return payload.attributes.media.map((item: any) => item["@id"])
})

// fetch assets from GQL
assetIds.value.map(async (media: string) => {
  try {
    await assetsStore.fetchAsset(media)
  } catch (e) {}
})

const asset = computed(() => {
  return assetsStore.getAsset(assetIds.value[0])
})
</script>